'use client';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { Heading } from '../../ui/heading';
import { ProductBadge } from './product-badge';
import { ProductRating } from './product-rating';
import { getContrastYIQ } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

export function ProductHeader({ deal }: { deal?: string }) {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const product = useVariantsStore(state => state.product);

  const hasVariants = (product?.variants?.length ?? 0) > 0;
  const activeItem = hasVariants ? (selectedVariant ?? product) : product;
  const isWholesaler = useCustomerStore(s => s.me?.customer.is_wholesaler);
  const priceWithoutVatFirst = useGlobalStore(
    s => s.templateSettings.product_detail?.price_without_vat_first?.enabled,
  );
  const priceDisplay = getProductPriceDisplay(activeItem, {
    isWholesaler,
    priceWithoutVatFirst,
  });

  return (
    <div className="flex w-full flex-col items-start justify-start gap-3 sm:gap-4">
      <div className="flex w-full flex-wrap items-start justify-start gap-2">
        {!!deal && <ProductBadge text={deal} background="#00923F" color={'#FFFFFF'} />}
        {product?.tags &&
          product?.tags?.length > 0 &&
          product.tags.map(tag => (
            <ProductBadge
              key={tag.name}
              text={tag.name}
              background={tag?.color ?? ''}
              color={getContrastYIQ(tag?.color ?? '')}
            />
          ))}
        {priceDisplay.showPreviousPrice && (
          <ProductBadge
            color="#FFFFFF"
            background={'#C31E1E'}
            text={`-${priceDisplay.discountLabel}%`}
          />
        )}
      </div>

      <Heading
        title={activeItem?.name ?? ''}
        tag={deal ? 'h3' : 'h1'}
        className={{ title: 'h3 text-[#111827]' }}
      />
      <Paragraph color="neutral" size="base">
        SKU: CCA4220 CA4220SS
      </Paragraph>
      {!!product?.rating && (product?.ratingCount ?? 0) > 0 && (
        <ProductRating rating={product?.rating} ratingCount={product.ratingCount} />
      )}
    </div>
  );
}
